import React from 'react';
import { RegisterOptions } from 'react-hook-form/dist/index.ie11';
import { BasePhoneNumberInput } from 'src/components/common/BasePhoneNumberInput/BasePhoneNumberInput';
import { addAsterisk } from 'src/components/enterprise/features/Corporate/components/Form/utils/addAsterisk';

export interface InvoiceContactPhoneNumberProps {
  name: string;
  id: string;
  rules?: RegisterOptions;
}

export const InvoiceContactPhoneNumberControl: React.FC<InvoiceContactPhoneNumberProps> =
  ({ name, id, rules }) => {
    return (
      <BasePhoneNumberInput
        name={name}
        id={id}
        label={addAsterisk('Direct phone', rules)}
        rules={{
          ...rules,
        }}
      />
    );
  };
